// Preset color palette for user-defined tags.
// Keep light bg + dark text + matching border so pills read well on both cards and rows.
export const TAG_COLORS = {
  yellow: { classes: "bg-yellow-100 text-yellow-800 border-yellow-300", swatch: "bg-yellow-300" },
  green: { classes: "bg-green-100 text-green-800 border-green-300", swatch: "bg-green-400" },
  blue: { classes: "bg-blue-100 text-blue-800 border-blue-300", swatch: "bg-blue-400" },
  red: { classes: "bg-red-100 text-red-800 border-red-300", swatch: "bg-red-400" },
  purple: { classes: "bg-purple-100 text-purple-800 border-purple-300", swatch: "bg-purple-400" },
  pink: { classes: "bg-pink-100 text-pink-800 border-pink-300", swatch: "bg-pink-400" },
  orange: { classes: "bg-orange-100 text-orange-800 border-orange-300", swatch: "bg-orange-400" },
  teal: { classes: "bg-teal-100 text-teal-800 border-teal-300", swatch: "bg-teal-400" },
  indigo: { classes: "bg-indigo-100 text-indigo-800 border-indigo-300", swatch: "bg-indigo-400" },
  gray: { classes: "bg-gray-100 text-gray-700 border-gray-300", swatch: "bg-gray-400" },
};

export const TAG_COLOR_KEYS = Object.keys(TAG_COLORS);

export const DEFAULT_TAGS = [
  { id: "default-personal-expense", label: "Personal Expense", color: "yellow" },
  { id: "default-sales", label: "Sales", color: "green" },
];

export const colorClasses = (color) =>
  TAG_COLORS[color]?.classes || TAG_COLORS.gray.classes;

export const tagClasses = (label, tags) => {
  const list = Array.isArray(tags) ? tags : [];
  const found = list.find((t) => t.label === label);
  return colorClasses(found?.color);
};
